// cartStorage.js
export const getGuestCart = () => {
  return JSON.parse(localStorage.getItem("guest_cart")) || [];
};

export const setGuestCart = (cart) => {
  localStorage.setItem("guest_cart", JSON.stringify(cart));
};

export const clearGuestCart = () => {
  localStorage.removeItem("guest_cart");
};
